import ToolTip from '@/shared/Common/Tooltip'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import cn from '@/utils/cn'
import { useCallback } from 'react'
import liftPlateContactMatrixUtils from '../liftPlateContactMatrix.utils'
import css from '../lpPlateContactsMatrix.module.css'
import liftPlateContactsMatrixConfig from '../liftPlateContactsMatrix.config'
import { TParameterKey } from '@/pages/Parameters/parameters.types'
import parametersSelectors from '@/pages/Parameters/parameters.selectors'
import { useRecoilValue } from 'recoil'

interface IProps {
  values: Record<TParameterKey, number>
  loading: boolean
}

const LiftPlateContactsMatrixWidget = (props: IProps) => {
  const sourceIdToIdMap = useRecoilValue(parametersSelectors.getSourceIdToIdMap)

  const handleElementMouseOver = useCallback((el: string) => {
    const [mC, SK] = el.split('_')
    const mC_value = parseInt(mC.substring(2))
    const SK_value = parseInt(SK.substring(2))

    const SKDomElement = document.getElementById(`SK_${SK_value}`)
    const mCDomElement = document.getElementById(`SC_${mC_value}`)

    if (SKDomElement && mCDomElement) {
      SKDomElement.style.background = 'var(--primary)'
      SKDomElement.style.color = '#fff'
      mCDomElement.style.background = 'var(--primary)'
      mCDomElement.style.color = '#fff'
    }
  }, [])

  const handleElementMouseLeave = useCallback((el: string) => {
    const [mC, SK] = el.split('_')
    const mC_value = parseInt(mC.substring(2))
    const SK_value = parseInt(SK.substring(2))

    const SKDomElement = document.getElementById(`SK_${SK_value}`)
    const mCDomElement = document.getElementById(`SC_${mC_value}`)

    if (SKDomElement && mCDomElement) {
      SKDomElement.style.background = ''
      SKDomElement.style.color = ''

      mCDomElement.style.background = ''
      mCDomElement.style.color = ''
    }
  }, [])

  return (
    <div className="flex-lines gap16" style={{ minHeight: 0, position: 'relative' }}>
      {props.loading && (
        <div className={css.loadingOverlay}>
          <ThreeDotsLoader inscription="Загрузка данных..." />
        </div>
      )}
      <div className="inline-flex-gap gap16">
        <div className="inline-flex-gap gap8 center">
          <div className={css.colorBlock} data-descriptor="up-call" />
          <p className="text-nm">Вызов вверх;</p>
        </div>
        <div className="inline-flex-gap gap8 center">
          <div className={css.colorBlock} data-descriptor="down-call" />
          <p className="text-nm">Вызов вниз;</p>
        </div>
        <div className="inline-flex-gap gap8 center">
          <div className={css.colorBlock} data-descriptor="order" />
          <p className="text-nm">Приказ;</p>
        </div>
        <div className="inline-flex-gap gap8 center">
          <div className={css.colorBlock} data-descriptor="active" />
          <p className="text-nm">Есть сигнал</p>
        </div>
      </div>
      <div className={css.wrapper}>
        <div className={cn(css.item, css.heading)}>
          <p className={cn(css.itemCell, 'text-nm')}>Имя</p>
          {new Array(8).fill(0).map((_, index) => (
            <p className={cn(css.itemCell, 'text-nm text-center')} id={`SC_${index + 1}`} key={`SC_${index + 1}`}>
              SC{index + 1}
            </p>
          ))}
        </div>
        {liftPlateContactsMatrixConfig.sourceParametersMap.map((rowValues, ind) => (
          <div className={css.item} key={ind}>
            <div className={css.itemCell} id={`SK_${ind + 1}`} key={`SK_${ind + 1}`}>
              SK{ind + 1}
            </div>
            {rowValues.map((r, rIndex) => (
              <div
                className={cn(css.itemCell, 'text-nm text-center')}
                key={r}
                onMouseEnter={() => handleElementMouseOver(r)}
                onMouseLeave={() => handleElementMouseLeave(r)}
                data-descriptor={liftPlateContactMatrixUtils.getParameterColorDescriptor(r)}
                data-active={props.values[sourceIdToIdMap[r]] === 1}
              >
                <ToolTip
                  text={liftPlateContactMatrixUtils.getParameterTooltipText(r)}
                  position={rIndex === 7 ? 'left' : ind > 3 ? 'top' : 'bottom'}
                  delay={50}
                >
                  {liftPlateContactMatrixUtils.parameterTranslation(r)}
                </ToolTip>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default LiftPlateContactsMatrixWidget
